const errors = {
  required: 'Este campo es obligatorio',
  requiredTrue: 'Debe aceptar este campo para proseguir',
  badCharacters: 'Este campo contiene carácteres inválidos',
  cuitAlreadyTaken: 'Ya existe una cuenta con este cuit',
  badCUIT: 'El CUIT/CUIL que ingresó es inválido',
  minlength: 'Este campo debe contener al menos 8 caracteres',
  notRepeated: 'Las contraseñas no coinciden',
  pattern:
    'La contraseña debe tener al menos: un número, una mayúscula, una minúscula y un caracter especial (#$^+=-_!*()@%&.,?"\')',
  invalidCredentials: 'Las credenciales son incorrectas',
  emailAlreadyTaken: 'Ya existe una cuenta con este email',
  dniAlreadyTaken: 'Ya existe una cuenta con ese dni',
  emailDoesntExist: 'No existe una cuenta con ese email asociado.',
  email: 'Ingrese un email válido',
  max: 'Numero de dni inválido',
  maxlength: 'El campo es muy largo',
  passwordnomatch: 'Las contraseñas no coinciden',
  passwordMatch: 'La nueva contraseña debe ser diferente a la anterior',
  requiredshort: 'Requerido',
  minlengthsix: 'Este campo debe contener al menos 6 caracteres',
  minlengthfour: 'Este campo debe contener al menos 4 caracteres',
  minlengththree: 'Este campo debe contener al menos 3 caracteres',
  usernotexists: 'Este usuario no forma parte de la plataforma',
  useralreadyexclusive: 'Este usuario ya disfruta este beneficio',
  phoneShort: 'Mínimo de 10 dígitos',
  invalidUIF: 'Declaración UIF inválida',
  blocked: 'Su usario fue bloqueado. Intente en 5 minutos',
  cuilMin: 'El CUIT o CUIL debe tener 11 dígitos',
  notNumber: 'Este campo solo permite números',
  bad2faCode: 'El código ingresado es incorrecto, intentá nuevamente',
  invalidCbu: 'El CBU es inválido o no corresponde con tu CUIT/CUIL',
  accountAdded: 'Ya agregaste esta cuenta',
  cuitUnmatch: 'Esta cuenta no se encuentra asociada con su cuit',
  coinUnmatch: 'La cuenta ingresada no pertenece a la divisa solicitada',
  minlengthAddress: 'Este campo debe contener al menos 26 caracteres',
  invalidAddress: 'Dirección inválida',
  minSalary: 'El salario debe ser mayor a 0',
  employeeExist: 'Ya existe un empleado con este CUIT',
  cuitSameAsOwn: 'No se permite agregar su propio CUIT',
  invalidColor:
    'El color elegido podría ocasionar problemas al momento de escanear el QR. Elija un color más oscuro.',
  bannedCbu: 'El CBU es inválido, por favor intente con otro',
  invalidEmail: 'El email que ingresaste no es válido',
};

export default errors;
